import React, {useState} from 'react';
import {useTranslation, Trans} from 'react-i18next';
import { toggleLanguage } from "../redux/langAction";
import { useDispatch } from "react-redux";
import i18n from "../i18n"
import { NavDropdown } from 'react-bootstrap';

const ChangeLanguageButton = () => {
    const { t, i18n } = useTranslation();
    const [lng, setLng] = useState('en');
    const dispatch = useDispatch();
    const [displayLang, setDisplayLang] = useState('Spanish');

    const changeLanguage = async () => {
      window.language = (lng === 'en') ? 'es' : 'en';
      setLng(window.language);
      dispatch(toggleLanguage(window.language))
      i18n.changeLanguage(window.language);
      setDisplayLang(lng === 'en' ? 'English' : 'Spanish');
    };
    
    return (

       <div className="text-light">
          <NavDropdown.Item className='!font-bold' onClick={()=> changeLanguage()}><Trans i18nKey={t(displayLang)}/></NavDropdown.Item>
       </div>
       
    );
  }
  
  export default ChangeLanguageButton;
  